import { HttpClient } from '@angular/common/http';
import {
  AddExamContentEcosPayload,
  UpdateExamContentEcosPayload,
  UpdateExamContentEcosPictogramPayload,
  UpdateExamContentEcosPicturePayload,
} from '../../../shared/models/payloads/exam-content-ecos.payload';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { AddedEntity } from '../../../shared/models/api-results/base.api-result';
import { convertToFormData } from '../../../shared/utils/api-transformations';
import {
  ExamContentEcosResult,
  UpdateExamContentEcosPatientPictogramResult,
  UpdateExamContentEcosPictureResult,
} from '../../../shared/models/api-results/exam-content-ecos.api-result';
import {
  AddEcosDebriefPictureResult,
  EcosDebriefResult,
} from '../../../shared/models/api-results/ecos-debrief.api-result';
import {
  AddEcosDebriefPicturePayload,
  UpdateEcosDebriefPayload,
} from '../../../shared/models/payloads/ecos-debrief.payload';

@Injectable({
  providedIn: 'root',
})
export class HttpExamContentEcosService {
  constructor(private http: HttpClient) {}

  get(id: string) {
    return this.http
      .get(`${environment.api_base_url}/exam_contents_ecos/get_exam_contents_ecos_details/${id}`)
      .pipe(map((res) => res as ExamContentEcosResult));
  }

  wAdd(examContentId: string, payload: AddExamContentEcosPayload) {
    return this.http
      .post(
        `${environment.api_base_url}/exam_contents_ecos/add_exam_content_ecos/${examContentId}`,
        convertToFormData(payload)
      )
      .pipe(map((res) => res as AddedEntity));
  }

  wUpdate(id: string, payload: UpdateExamContentEcosPayload) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents_ecos/update_exam_content_ecos/${id}`,
      payload
    );
  }

  wUpdatePicture(id: string, payload: UpdateExamContentEcosPicturePayload) {
    return this.http
      .post(
        `${environment.api_base_url}/exam_contents_ecos/update_exam_content_ecos_picture/${id}`,
        convertToFormData(payload)
      )
      .pipe(map((res) => res as UpdateExamContentEcosPictureResult));
  }

  wUpdatePatientPictogram(id: string, payload: UpdateExamContentEcosPictogramPayload) {
    return this.http
      .post(
        `${environment.api_base_url}/exam_contents_ecos/update_exam_content_ecos_patient_pictogram/${id}`,
        convertToFormData(payload)
      )
      .pipe(map((res) => res as UpdateExamContentEcosPatientPictogramResult));
  }

  wAssociateCourseToExamContentEcos(examContentId: string, courseId: string) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents_ecos/${examContentId}/associate_course_to_exam_content_ecos/${courseId}`,
      {}
    );
  }

  wDissociateCourseFromExamContentEcos(examContentId: string, courseId: string) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents_ecos/${examContentId}/dissociate_course_from_exam_content_ecos/${courseId}`,
      {}
    );
  }

  wRecomputeEcosSessions(examContentId: string) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents_ecos/recompute_exam_content_ecos_sessions/${examContentId}`,
      {}
    );
  }
}
